import { useQuery } from "@airdrop/hooks/useQuery";
import AllAirdropsGrid from "@airdrop/components/AllAirdropsGrid";
import PageHead from "@/components/common/PageHead";
import Container from "@airdrop/components/Container";
import { isMaintenance } from "@/config/config";
import Maintenance from "@/components/common/Maintenance";

const Campaigns = () => {
  const page = useQuery();

  const type = page.get("type") ? page.get("type") : "ALL";
  const pageNumber = page.get("page") ? page.get("page") : 1;

  return (
    <Container>
      <PageHead></PageHead>
      <div
        className="bg-trendingBg bg-contain bg-no-repeat"
        style={{
          backgroundPosition: "left -90px",
        }}
      >
        <div className="mb-28 w-full max-w-5xl px-6 mx-auto pt-[100px]">
          {isMaintenance ? (
            <Maintenance></Maintenance>
          ) : (
            <AllAirdropsGrid pageNum={pageNumber} type={type} />
          )}
        </div>
      </div>
    </Container>
  );
};

export default Campaigns;
